/*!
 * Cube Portfolio - Responsive jQuery Grid Plugin
 *
 * version: 2.3.3 (16 June, 2015)
 * require: jQuery v1.7+
 *
 * Copyright 2013-2015, Mihai Buricea (http://scriptpie.com/cubeportfolio/live-preview/)
 * Licensed under CodeCanyon License (http://codecanyon.net/licenses)
 *
 */
!(function(a, b, c, d) {
  "use strict";
  function e(b, c, d) {
    var f,
      g = this,
      h = "cbp";
    if (a.data(b, "cubeportfolio"))
      throw new Error(
        "cubeportfolio is already initialized. Destroy it before initialize again!"
      );
    a.data(b, "cubeportfolio", g),
      (g.options = a.extend({}, a.fn.cubeportfolio.options, c)),
      (g.isAnimating = !0),
      (g.defaultFilter = g.options.defaultFilter),
      (g.registeredEvents = []),
      (g.skipEvents = []),
      (g.addedWrapp = !1),
      a.isFunction(d) && g._registerEvent("initFinish", d, !0),
      (g.obj = b),
      (g.$obj = a(b)),
      (f = g.$obj.children()),
      g.options.caption &&
        (e.Private.modernBrowser || (g.options.caption = "minimal"),
        (h += " cbp-caption-active cbp-caption-" + g.options.caption)),
      g.$obj.addClass(h),
      (0 === f.length || f.first().hasClass("cbp-item")) &&
        (g.wrapInner(g.obj, "cbp-wrapper"), (g.addedWrapp = !0)),
      (g.$ul = g.$obj.children().addClass("cbp-wrapper")),
      g.wrapInner(g.obj, "cbp-wrapper-outer"),
      (g.wrapper = g.$obj.children(".cbp-wrapper-outer")),
      (g.blocks = g.$ul.children(".cbp-item")),
      g.wrapInner(g.blocks, "cbp-item-wrapper"),
      (g.width = g.$obj.outerWidth()),
      g._load(g.$obj, g._display);
  }
  a.extend(e.prototype, {
    storeData: function(b) {
      b.each(function(b, c) {
        var d = a(c);
        d.data("cbp", {
          wrapper: d.children(".cbp-item-wrapper"),
          widthInitial: d.outerWidth(),
          heightInitial: d.outerHeight(),
          width: null,
          height: null,
          left: null,
          leftNew: null,
          top: null,
          topNew: null
        });
      });
    },
    wrapInner: function(a, b) {
      var e, f, g;
      if (((b = b || ""), !(a.length && a.length < 1)))
        for (a.length === d && (a = [a]), f = a.length - 1; f >= 0; f--) {
          for (
            e = a[f], g = c.createElement("div"), g.setAttribute("class", b);
            e.childNodes.length;

          )
            g.appendChild(e.childNodes[0]);
          e.appendChild(g);
        }
    },
    _captionDestroy: function() {
      var a = this;
      a.$obj.removeClass("cbp-caption-active cbp-caption-" + a.options.caption);
    },
    resizeEvent: function() {
      var c,
        d,
        e = this;
      a(b).on("resize.cbp", function() {
        clearTimeout(c),
          (c = setTimeout(function() {
            b.innerHeight != screen.height &&
              ("alignCenter" === e.options.gridAdjustment &&
                (e.obj.style.maxWidth = ""),
              (d = e.$obj.outerWidth()),
              e.width !== d &&
                ((e.width = d),
                e._gridAdjust(),
                e._layout(),
                e.positionateItems(),
                e._resizeMainContainer(),
                "slider" === e.options.layoutMode && e._updateSlider(),
                e._triggerEvent("resizeGrid")),
              e._triggerEvent("resizeWindow"));
          }, 80));
      });
    },
    _load: function(b, c, d) {
      var e,
        f,
        g = this,
        h = 0;
      (d = d || []),
        (e = b.find("img:uncached").map(function() {
          return this.src;
        })),
        (f = e.length),
        0 === f && c.apply(g, d),
        a.each(e, function(b, e) {
          var i = new Image();
          a(i).one("load.cbp error.cbp", function() {
            return (
              a(this).off("load.cbp error.cbp"),
              h++,
              h === f ? (c.apply(g, d), !1) : void 0
            );
          }),
            (i.src = e);
        });
    },
    _filterFromUrl: function() {
      var a = this,
        b = /#cbpf=(.*?)([#|?&]|$)/gi.exec(location.href);
      null !== b && (a.defaultFilter = b[1]);
    },
    _display: function() {
      var b = this;
      b.storeData(b.blocks),
        "grid" === b.options.layoutMode && b._filterFromUrl(),
        "*" !== b.defaultFilter
          ? ((b.blocksOn = b.blocks.filter(b.defaultFilter)),
            b.blocks.not(b.defaultFilter).addClass("cbp-item-off"))
          : (b.blocksOn = b.blocks),
        (b._plugins = a.map(e.Plugins, function(a) {
          return a(b);
        })),
        b._triggerEvent("initStartRead"),
        b._triggerEvent("initStartWrite"),
        (b.localColumnWidth = b.options.gapVertical),
        b.blocks.length &&
          (b.localColumnWidth += b.blocks.first().data("cbp").widthInitial),
        (b.getColumnsType = a.isArray(b.options.mediaQueries)
          ? "_getColumnsBreakpoints"
          : "_getColumnsAuto"),
        b._gridAdjust(),
        b["_" + b.options.layoutMode + "Markup"](),
        b._layout(),
        b.positionateItems(),
        b._resizeMainContainer(),
        b._triggerEvent("initEndRead"),
        b._triggerEvent("initEndWrite"),
        b.$obj.addClass("cbp-ready"),
        b._registerEvent("delayFrame", b.delayFrame),
        b._triggerEvent("delayFrame");
    },
    positionateItems: function() {
      var b,
        c = this;
      c.blocksOn.each(function(c, d) {
        (b = a(d).data("cbp")),
          (b.left = b.leftNew),
          (b.top = b.topNew),
          (d.style.left = b.left + "px"),
          (d.style.top = b.top + "px");
      });
    },
    delayFrame: function() {
      var a = this;
      requestAnimationFrame(function() {
        a.resizeEvent(),
          a._triggerEvent("initFinish"),
          (a.isAnimating = !1),
          a.$obj.trigger("initComplete.cbp");
      });
    },
    _gridAdjust: function() {
      var b = this;
      "responsive" === b.options.gridAdjustment
        ? b._responsiveLayout()
        : b.blocks.each(function(b, c) {
            var d = a(c).data("cbp");
            (d.width = d.widthInitial), (d.height = d.heightInitial);
          });
    },
    _layout: function() {
      var a = this;
      a["_" + a.options.layoutMode + "LayoutReset"](),
        a["_" + a.options.layoutMode + "Layout"](),
        a.$obj.removeClass(function(a, b) {
          return (b.match(/\bcbp-cols-\d+/gi) || []).join(" ");
        }),
        a.$obj.addClass("cbp-cols-" + a.cols);
    },
    _sliderMarkup: function() {
      var b = this;
      (b.sliderStopEvents = !1),
        (b.sliderActive = 0),
        b._registerEvent(
          "updateSliderPosition",
          function() {
            b.$obj.addClass("cbp-mode-slider");
          },
          !0
        ),
        (b.nav = a("<div/>", { class: "cbp-nav" })),
        b.nav.on("click.cbp", "[data-slider-action]", function(c) {
          if (
            (c.preventDefault(),
            c.stopImmediatePropagation(),
            c.stopPropagation(),
            !b.sliderStopEvents)
          ) {
            var d = a(this),
              e = d.attr("data-slider-action");
            b["_" + e + "Slider"] && b["_" + e + "Slider"](d);
          }
        }),
        b.options.showNavigation &&
          ((b.controls = a("<div/>", { class: "cbp-nav-controls" })),
          (b.navPrev = a("<div/>", {
            class: "cbp-nav-prev",
            "data-slider-action": "prev"
          }).appendTo(b.controls)),
          (b.navNext = a("<div/>", {
            class: "cbp-nav-next",
            "data-slider-action": "next"
          }).appendTo(b.controls)),
          b.controls.appendTo(b.nav)),
        b.options.showPagination &&
          (b.navPagination = a("<div/>", {
            class: "cbp-nav-pagination"
          }).appendTo(b.nav)),
        (b.controls || b.navPagination) && b.nav.appendTo(b.$obj),
        b._updateSliderPagination(),
        b.options.auto &&
          (b.options.autoPauseOnHover &&
            ((b.mouseIsEntered = !1),
            b.$obj
              .on("mouseenter.cbp", function() {
                (b.mouseIsEntered = !0), b._stopSliderAuto();
              })
              .on("mouseleave.cbp", function() {
                (b.mouseIsEntered = !1), b._startSliderAuto();
              })),
          b._startSliderAuto()),
        b.options.drag && e.Private.modernBrowser && b._dragSlider();
    },
    _updateSlider: function() {
      var a = this;
      a._updateSliderPosition(), a._updateSliderPagination();
    },
    _updateSliderPagination: function() {
      var b,
        c,
        d = this;
      if (d.options.showPagination) {
        for (
          b = Math.ceil(d.blocksOn.length / d.cols),
            d.navPagination.empty(),
            c = b - 1;
          c >= 0;
          c--
        )
          a("<div/>", {
            class: "cbp-nav-pagination-item",
            "data-slider-action": "jumpTo"
          }).appendTo(d.navPagination);
        d.navPaginationItems = d.navPagination.children();
      }
      d._enableDisableNavSlider();
    },
    _destroySlider: function() {
      var a = this;
      "slider" === a.options.layoutMode &&
        (a.$obj.off("click.cbp"),
        a.$obj.removeClass("cbp-mode-slider"),
        a.options.showNavigation && a.nav.remove(),
        a.navPagination && a.navPagination.remove());
    },
    _nextSlider: function() {
      var a = this;
      if (a._isEndSlider()) {
        if (!a.isRewindNav()) return;
        a.sliderActive = 0;
      } else
        a.options.scrollByPage
          ? (a.sliderActive = Math.min(
              a.sliderActive + a.cols,
              a.blocksOn.length - a.cols
            ))
          : (a.sliderActive += 1);
      a._goToSlider();
    },
    _prevSlider: function() {
      var a = this;
      if (a._isStartSlider()) {
        if (!a.isRewindNav()) return;
        a.sliderActive = a.blocksOn.length - a.cols;
      } else
        a.options.scrollByPage
          ? (a.sliderActive = Math.max(0, a.sliderActive - a.cols))
          : (a.sliderActive -= 1);
      a._goToSlider();
    },
    _jumpToSlider: function(a) {
      var b = this,
        c = Math.min(a.index() * b.cols, b.blocksOn.length - b.cols);
      c !== b.sliderActive && ((b.sliderActive = c), b._goToSlider());
    },
    _jumpDragToSlider: function(a) {
      var b,
        c,
        d,
        e = this,
        f = a > 0 ? !0 : !1;
      e.options.scrollByPage
        ? ((b = e.cols * e.localColumnWidth), (c = e.cols))
        : ((b = e.localColumnWidth), (c = 1)),
        (a = Math.abs(a)),
        (d = Math.floor(a / b) * c),
        a % b > 20 && (d += c),
        (e.sliderActive = f
          ? Math.min(e.sliderActive + d, e.blocksOn.length - e.cols)
          : Math.max(0, e.sliderActive - d)),
        e._goToSlider();
    },
    _isStartSlider: function() {
      return 0 === this.sliderActive;
    },
    _isEndSlider: function() {
      var a = this;
      return a.sliderActive + a.cols > a.blocksOn.length - 1;
    },
    _goToSlider: function() {
      var a = this;
      a._enableDisableNavSlider(), a._updateSliderPosition();
    },
    _startSliderAuto: function() {
      var a = this;
      return a.isDrag
        ? void a._stopSliderAuto()
        : void (a.timeout = setTimeout(function() {
            a._nextSlider(), a._startSliderAuto();
          }, a.options.autoTimeout));
    },
    _stopSliderAuto: function() {
      clearTimeout(this.timeout);
    },
    _enableDisableNavSlider: function() {
      var a,
        b,
        c = this;
      c.isRewindNav() ||
        ((b = c._isStartSlider() ? "addClass" : "removeClass"),
        c.navPrev[b]("cbp-nav-stop"),
        (b = c._isEndSlider() ? "addClass" : "removeClass"),
        c.navNext[b]("cbp-nav-stop")),
        c.options.showPagination &&
          ((a = c.options.scrollByPage
            ? Math.ceil(c.sliderActive / c.cols)
            : c._isEndSlider()
            ? c.navPaginationItems.length - 1
            : Math.floor(c.sliderActive / c.cols)),
          c.navPaginationItems
            .removeClass("cbp-nav-pagination-active")
            .eq(a)
            .addClass("cbp-nav-pagination-active"));
    },
    isRewindNav: function() {
      var a = this;
      return a.options.showNavigation
        ? a.blocksOn.length <= a.cols
          ? !1
          : a.options.rewindNav
          ? !0
          : !1
        : !0;
    },
    sliderItemsLength: function() {
      return this.blocksOn.length <= this.cols;
    },
    _sliderLayout: function() {
      var b = this;
      b.blocksOn.each(function(c, d) {
        var e = a(d).data("cbp");
        (e.leftNew = Math.round(b.localColumnWidth * c)),
          (e.topNew = 0),
          b.colVert.push(e.height + b.options.gapHorizontal);
      }),
        (b.sliderColVert = b.colVert.slice(
          b.sliderActive,
          b.sliderActive + b.cols
        )),
        (b.ulWidth =
          b.localColumnWidth * b.blocksOn.length - b.options.gapVertical),
        b.$ul.width(b.ulWidth);
    },
    _updateSliderPosition: function() {
      var a = this,
        b = -a.sliderActive * a.localColumnWidth;
      a._triggerEvent("updateSliderPosition"),
        e.Private.modernBrowser
          ? (a.$ul[0].style[e.Private.transform] =
              "translate3d(" + b + "px, 0px, 0)")
          : (a.$ul[0].style.left = b + "px"),
        (a.sliderColVert = a.colVert.slice(
          a.sliderActive,
          a.sliderActive + a.cols
        )),
        a._resizeMainContainer();
    },
    _dragSlider: function() {
      function f(b) {
        if (!q.sliderItemsLength()) {
          if (
            (u ? (p = b) : b.preventDefault(),
            q.options.auto && q._stopSliderAuto(),
            s)
          )
            return void a(m).one("click.cbp", function() {
              return !1;
            });
          (m = a(b.target)),
            (k = j(b).x),
            (l = 0),
            (n = -q.sliderActive * q.localColumnWidth),
            (o = q.localColumnWidth * (q.blocksOn.length - q.cols)),
            r.on(t.move, h),
            r.on(t.end, g),
            q.$obj.addClass("cbp-mode-slider-dragStart");
        }
      }
      function g() {
        q.$obj.removeClass("cbp-mode-slider-dragStart"),
          (s = !0),
          0 !== l
            ? (m.one("click.cbp", function() {
                return !1;
              }),
              q._jumpDragToSlider(l),
              q.$ul.one(e.Private.transitionend, i))
            : i.call(q),
          r.off(t.move),
          r.off(t.end);
      }
      function h(a) {
        (l = k - j(a).x),
          (l > 8 || -8 > l) && a.preventDefault(),
          (q.isDrag = !0);
        var b = n - l;
        0 > l && n > l
          ? (b = (n - l) / 5)
          : l > 0 && -o > n - l && (b = -o + (o + n - l) / 5),
          e.Private.modernBrowser
            ? (q.$ul[0].style[e.Private.transform] =
                "translate3d(" + b + "px, 0px, 0)")
            : (q.$ul[0].style.left = b + "px");
      }
      function i() {
        if (((s = !1), (q.isDrag = !1), q.options.auto)) {
          if (q.mouseIsEntered) return;
          q._startSliderAuto();
        }
      }
      function j(a) {
        return (
          a.originalEvent !== d &&
            a.originalEvent.touches !== d &&
            (a = a.originalEvent.touches[0]),
          { x: a.pageX, y: a.pageY }
        );
      }
      var k,
        l,
        m,
        n,
        o,
        p,
        q = this,
        r = a(c),
        s = !1,
        t = {},
        u = !1;
      (q.isDrag = !1),
        "ontouchstart" in b ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
          ? ((t = {
              start: "touchstart.cbp",
              move: "touchmove.cbp",
              end: "touchend.cbp"
            }),
            (u = !0))
          : (t = {
              start: "mousedown.cbp",
              move: "mousemove.cbp",
              end: "mouseup.cbp"
            }),
        q.$ul.on(t.start, f);
    },
    _sliderLayoutReset: function() {
      var a = this;
      a.colVert = [];
    },
    _gridMarkup: function() {},
    _gridLayout: function() {
      var b = this;
      b.blocksOn.each(function(c, d) {
        var e,
          f,
          g,
          h,
          i = Math.min.apply(Math, b.colVert),
          j = 0,
          k = a(d).data("cbp");
        for (g = 0, h = b.colVert.length; h > g; g++)
          if (b.colVert[g] === i) {
            j = g;
            break;
          }
        for (
          k.leftNew = Math.round(b.localColumnWidth * j),
            k.topNew = Math.round(i),
            e = i + k.height + b.options.gapHorizontal,
            f = b.cols + 1 - h,
            g = 0;
          f > g;
          g++
        )
          b.colVert[j + g] = e;
      });
    },
    _gridLayoutReset: function() {
      var a,
        b = this;
      for (
        "alignCenter" === b.options.gridAdjustment
          ? ((b.cols = Math.max(
              Math.floor(
                (b.width + b.options.gapVertical) / b.localColumnWidth
              ),
              1
            )),
            (b.width = b.cols * b.localColumnWidth - b.options.gapVertical),
            b.$obj.css("max-width", b.width))
          : (b.cols = Math.max(
              Math.floor(
                (b.width + b.options.gapVertical) / b.localColumnWidth
              ),
              1
            )),
          b.colVert = [],
          a = b.cols;
        a--;

      )
        b.colVert.push(0);
    },
    _responsiveLayout: function() {
      var b,
        c,
        d = this;
      d.columnWidthCache
        ? (d.localColumnWidth = d.columnWidthCache)
        : (d.columnWidthCache = d.localColumnWidth),
        (d.cols = d[d.getColumnsType]()),
        (b = d.width - d.options.gapVertical * (d.cols - 1)),
        (d.localColumnWidth = parseInt(b / d.cols, 10) + d.options.gapVertical),
        (c = d.localColumnWidth - d.options.gapVertical),
        d.blocks.each(function(b, d) {
          (d.style.width = c + "px"), (a(d).data("cbp").width = c);
        }),
        d.blocks.each(function(b, c) {
          var d = a(c);
          d.data("cbp").height = d.outerHeight();
        });
    },
    _getColumnsAuto: function() {
      var a = this;
      return Math.max(Math.round(a.width / a.localColumnWidth), 1);
    },
    _getColumnsBreakpoints: function() {
      var b,
        c = this,
        e = c.width - c.options.gapVertical;
      return (
        a.each(c.options.mediaQueries, function(a, c) {
          return e >= c.width ? ((b = c.cols), !1) : void 0;
        }),
        b === d &&
          (b = c.options.mediaQueries[c.options.mediaQueries.length - 1].cols),
        b
      );
    },
    _resizeMainContainer: function() {
      var a,
        b = this,
        c = b.sliderColVert || b.colVert;
      (a = Math.max(Math.max.apply(Math, c) - b.options.gapHorizontal, 0)),
        a !== b.height &&
          ((b.obj.style.height = a + "px"),
          b.height !== d &&
            (e.Private.modernBrowser
              ? b.$obj.one(e.Private.transitionend, function() {
                  b.$obj.trigger("pluginResize.cbp");
                })
              : b.$obj.trigger("pluginResize.cbp")),
          (b.height = a));
    },
    _filter: function(a) {
      var b = this;
      (b.blocksOnInitial = b.blocksOn),
        (b.blocksOn = b.blocks.filter(a)),
        (b.blocksOff = b.blocks.not(a)),
        b._layout(),
        b.filterLayout(a);
    },
    filterLayout: function() {
      var b = this;
      b.blocksOff.addClass("cbp-item-off"),
        b.blocksOn.removeClass("cbp-item-off").each(function(b, c) {
          var d = a(c).data("cbp");
          (d.left = d.leftNew),
            (d.top = d.topNew),
            (c.style.left = d.left + "px"),
            (c.style.top = d.top + "px");
        }),
        b._resizeMainContainer(),
        b.filterFinish();
    },
    filterFinish: function() {
      var a = this;
      (a.isAnimating = !1),
        a.$obj.trigger("filterComplete.cbp"),
        a._triggerEvent("filterFinish");
    },
    _registerEvent: function(a, b, c) {
      var d = this;
      d.registeredEvents[a] || (d.registeredEvents[a] = []),
        d.registeredEvents[a].push({ func: b, oneTime: c || !1 });
    },
    _triggerEvent: function(a, b) {
      var c,
        d,
        e = this;
      if (e.skipEvents[a]) return void delete e.skipEvents[a];
      if (e.registeredEvents[a])
        for (c = 0, d = e.registeredEvents[a].length; d > c; c++)
          e.registeredEvents[a][c].func.call(e, b),
            e.registeredEvents[a][c].oneTime &&
              (e.registeredEvents[a].splice(c, 1), c--, d--);
    },
    _skipNextEvent: function(a) {
      var b = this;
      b.skipEvents[a] = !0;
    },
    _addItems: function(b, c) {
      var d = this,
        f = a(b)
          .filter(".cbp-item")
          .addClass("cbp-loading-fadeIn")
          .css("top", "1000%")
          .wrapInner('<div class="cbp-item-wrapper"></div>');
      return f.length
        ? void d._load(f, function() {
            d.$obj.addClass("cbp-addItems"),
              f.appendTo(d.$ul),
              a.merge(d.blocks, f),
              d.storeData(f),
              "*" !== d.defaultFilter
                ? ((d.blocksOn = d.blocks.filter(d.defaultFilter)),
                  d.blocks.not(d.defaultFilter).addClass("cbp-item-off"))
                : (d.blocksOn = d.blocks),
              f.on(e.Private.animationend, function() {
                d.$obj
                  .find(".cbp-loading-fadeIn")
                  .removeClass("cbp-loading-fadeIn"),
                  d.$obj.removeClass("cbp-addItems");
              }),
              d._triggerEvent("addItemsToDOM", f),
              d._gridAdjust(),
              d._layout(),
              d.positionateItems(),
              d._resizeMainContainer(),
              "slider" === d.options.layoutMode && d._updateSlider(),
              d.elems && e.Public.showCounter.call(d.obj, d.elems),
              e.Private.modernBrowser
                ? f.last().one(e.Private.animationend, function() {
                    (d.isAnimating = !1), a.isFunction(c) && c.call(d);
                  })
                : ((d.isAnimating = !1), a.isFunction(c) && c.call(d));
          })
        : ((d.isAnimating = !1), void (a.isFunction(c) && c.call(d)));
    }
  }),
    (a.fn.cubeportfolio = function(a, b, c) {
      return this.each(function() {
        if ("object" == typeof a || !a) return e.Public.init.call(this, a, c);
        if (e.Public[a]) return e.Public[a].call(this, b, c);
        throw new Error(
          "Method " + a + " does not exist on jquery.cubeportfolio.js"
        );
      });
    }),
    (a.fn.cubeportfolio.options = {
      filters: "",
      loadMore: "",
      loadMoreAction: "click",
      layoutMode: "grid",
      drag: !0,
      auto: !1,
      autoTimeout: 5e3,
      autoPauseOnHover: !0,
      showNavigation: !0,
      showPagination: !0,
      rewindNav: !0,
      scrollByPage: !1,
      defaultFilter: "*",
      filterDeeplinking: !1,
      animationType: "fadeOut",
      gridAdjustment: "responsive",
      mediaQueries: !1,
      gapHorizontal: 10,
      gapVertical: 10,
      caption: "pushTop",
      displayType: "lazyLoading",
      displayTypeSpeed: 400,
      lightboxDelegate: ".cbp-lightbox",
      lightboxGallery: !0,
      lightboxTitleSrc: "data-title",
      lightboxCounter:
        '<div class="cbp-popup-lightbox-counter">{{current}} of {{total}}</div>',
      singlePageDelegate: ".cbp-singlePage",
      singlePageDeeplinking: !0,
      singlePageStickyNavigation: !0,
      singlePageCounter:
        '<div class="cbp-popup-singlePage-counter">{{current}} of {{total}}</div>',
      singlePageAnimation: "left",
      singlePageCallback: function() {},
      singlePageInlineDelegate: ".cbp-singlePageInline",
      singlePageInlinePosition: "top",
      singlePageInlineInFocus: !0,
      singlePageInlineCallback: function() {}
    }),
    (e.Plugins = {}),
    (a.fn.cubeportfolio.Constructor = e);
})(jQuery, window, document),
  (function(a) {
    "use strict";
    function b(b) {
      var c = this;
      (c.parent = b),
        (c.filters = a(b.options.filters)),
        (c.wrap = a()),
        c.registerFilter();
    }
    var c = a.fn.cubeportfolio.Constructor;
    (b.prototype.registerFilter = function() {
      var b,
        c = this,
        d = c.parent;
      c.filters.each(function(e, f) {
        var g,
          h = a(f);
        h.hasClass("cbp-l-filters-dropdown")
          ? ((g = h.find(".cbp-l-filters-dropdownWrap")),
            g.on({
              "mouseover.cbp": function() {
                g.addClass("cbp-l-filters-dropdownWrap-open");
              },
              "mouseleave.cbp": function() {
                g.removeClass("cbp-l-filters-dropdownWrap-open");
              }
            }),
            (b = function(a) {
              g.find(".cbp-filter-item").removeClass("cbp-filter-item-active"),
                g.find(".cbp-l-filters-dropdownHeader").text(a.text()),
                a.addClass("cbp-filter-item-active"),
                g.trigger("mouseleave.cbp");
            }),
            c.wrap.add(g))
          : (b = function(a) {
              a.addClass("cbp-filter-item-active")
                .siblings()
                .removeClass("cbp-filter-item-active");
            }),
          b(
            h
              .find(".cbp-filter-item")
              .filter('[data-filter="' + d.defaultFilter + '"]')
          ),
          h.on("click.cbp", ".cbp-filter-item", function() {
            var c = a(this);
            c.hasClass("cbp-filter-item-active") ||
              (d.isAnimating || b.call(null, c),
              d.$obj.cubeportfolio("filter", c.data("filter")));
          }),
          d.$obj.cubeportfolio(
            "showCounter",
            h.find(".cbp-filter-item"),
            function() {
              var a,
                c = /#cbpf=(.*?)([#|?&]|$)/gi.exec(location.href);
              null !== c &&
                ((a = h
                  .find(".cbp-filter-item")
                  .filter('[data-filter="' + c[1] + '"]')),
                a.length && b.call(null, a));
            }
          );
      });
    }),
      (b.prototype.destroy = function() {
        var a = this;
        a.filters.off(".cbp"), a.wrap && a.wrap.off(".cbp");
      }),
      (c.Plugins.Filters = function(a) {
        return "" === a.options.filters ? null : new b(a);
      });
  })(jQuery, window, document),
  (function(a, b) {
    "use strict";
    function c(b) {
      var c = this;
      (c.parent = b),
        (c.loadMore = a(b.options.loadMore).find(".cbp-l-loadMore-link")),
        b.options.loadMoreAction.length && c[b.options.loadMoreAction]();
    }
    var d = a.fn.cubeportfolio.Constructor;
    (c.prototype.click = function() {
      var b = this,
        c = 0;
      b.loadMore.on("click.cbp", function(d) {
        var e = a(this);
        d.preventDefault(),
          e.hasClass("cbp-l-loadMore-stop") ||
            (e.addClass("cbp-l-loadMore-loading"),
            c++,
            a
              .ajax({
                url: b.loadMore.attr("href"),
                type: "GET",
                dataType: "HTML"
              })
              .done(function(d) {
                var f, g;
                (f = a(d).filter(function() {
                  return a(this).is("div.cbp-loadMore-block" + c);
                })),
                  b.parent.$obj.cubeportfolio(
                    "appendItems",
                    f.html(),
                    function() {
                      e.removeClass("cbp-l-loadMore-loading"),
                        (g = a(d).filter(function() {
                          return a(this).is("div.cbp-loadMore-block" + (c + 1));
                        })),
                        0 === g.length && e.addClass("cbp-l-loadMore-stop");
                    }
                  );
              })
              .fail(function() {}));
      });
    }),
      (c.prototype.auto = function() {
        var c = this;
        c.parent.$obj.on("initComplete.cbp", function() {
          Object.create({
            init: function() {
              var d = this;
              (d.isActive = !1),
                (d.numberOfClicks = 0),
                c.loadMore.addClass("cbp-l-loadMore-loading"),
                (d.window = a(b)),
                d.addEvents(),
                d.getNewItems();
            },
            addEvents: function() {
              var a,
                b = this;
              c.loadMore.on("click.cbp", function(a) {
                a.preventDefault();
              }),
                b.window.on("scroll.loadMoreObject", function() {
                  clearTimeout(a),
                    (a = setTimeout(function() {
                      c.parent.isAnimating || b.getNewItems();
                    }, 80));
                }),
                c.parent.$obj.on("filterComplete.cbp", function() {
                  b.getNewItems();
                });
            },
            getNewItems: function() {
              var b,
                d,
                e = this;
              e.isActive ||
                c.loadMore.hasClass("cbp-l-loadMore-stop") ||
                ((b = c.loadMore.offset().top),
                (d = e.window.scrollTop() + e.window.height()),
                b > d ||
                  ((e.isActive = !0),
                  e.numberOfClicks++,
                  a
                    .ajax({
                      url: c.loadMore.attr("href"),
                      type: "GET",
                      dataType: "HTML",
                      cache: !0
                    })
                    .done(function(b) {
                      var d, f;
                      (d = a(b).filter(function() {
                        return a(this).is(
                          "div.cbp-loadMore-block" + e.numberOfClicks
                        );
                      })),
                        c.parent.$obj.cubeportfolio(
                          "appendItems",
                          d.html(),
                          function() {
                            (f = a(b).filter(function() {
                              return a(this).is(
                                "div.cbp-loadMore-block" +
                                  (e.numberOfClicks + 1)
                              );
                            })),
                              0 === f.length
                                ? (c.loadMore.addClass("cbp-l-loadMore-stop"),
                                  e.window.off("scroll.loadMoreObject"),
                                  c.parent.$obj.off("filterComplete.cbp"))
                                : ((e.isActive = !1),
                                  e.window.trigger("scroll.loadMoreObject"));
                          }
                        );
                    })
                    .fail(function() {
                      e.isActive = !1;
                    })));
            }
          }).init();
        });
      }),
      (c.prototype.destroy = function() {
        var c = this;
        c.loadMore.off(".cbp"), a(b).off("scroll.loadMoreObject");
      }),
      (d.Plugins.LoadMore = function(a) {
        return "" === a.options.loadMore ? null : new c(a);
      });
  })(jQuery, window, document),
  (function(a, b, c) {
    "use strict";
    function d(a) {
      var b = this;
      (b.parent = a),
        a.options.lightboxShowCounter === !1 &&
          (a.options.lightboxCounter = ""),
        a.options.singlePageShowCounter === !1 &&
          (a.options.singlePageCounter = ""),
        b.run();
    }
    var e = a.fn.cubeportfolio.Constructor,
      f = {
        init: function(b, d) {
          var e,
            f = this;
          if (
            ((f.cubeportfolio = b),
            (f.type = d),
            (f.isOpen = !1),
            (f.options = f.cubeportfolio.options),
            "lightbox" === d &&
              f.cubeportfolio._registerEvent("resizeWindow", function() {
                f.resizeImage();
              }),
            "singlePageInline" === d)
          )
            return (
              (f.startInline = -1),
              (f.height = 0),
              f._createMarkupSinglePageInline(),
              void f.cubeportfolio._registerEvent("resizeGrid", function() {
                f.isOpen && f.close();
              })
            );
          if (
            (f._createMarkup(),
            "singlePage" === d &&
              (f.cubeportfolio._registerEvent("resizeWindow", function() {
                if (f.options.singlePageStickyNavigation) {
                  var a = f.wrap[0].clientWidth;
                  a > 0 && (f.navigationWrap.width(a), f.navigation.width(a));
                }
              }),
              f.options.singlePageDeeplinking))
          ) {
            (f.url = location.href),
              "#" === f.url.slice(-1) && (f.url = f.url.slice(0, -1));
            var g = f.url.split("#cbp="),
              h = g.shift();
            if (
              (a.each(g, function(b, c) {
                return (
                  f.cubeportfolio.blocksOn.each(function(b, d) {
                    var g = a(d).find(
                      f.options.singlePageDelegate + '[href="' + c + '"]'
                    );
                    return g.length ? ((e = g), !1) : void 0;
                  }),
                  e ? !1 : void 0
                );
              }),
              e)
            ) {
              f.url = h;
              var i = e,
                j = i.attr("data-cbp-singlePage"),
                k = [];
              j
                ? (k = i
                    .closest(a(".cbp-item"))
                    .find('[data-cbp-singlePage="' + j + '"]'))
                : f.cubeportfolio.blocksOn.each(function(b, c) {
                    var d = a(c);
                    d.not(".cbp-item-off") &&
                      d.find(f.options.singlePageDelegate).each(function(b, c) {
                        a(c).attr("data-cbp-singlePage") || k.push(c);
                      });
                  }),
                f.openSinglePage(k, e[0]);
            } else if (g.length) {
              var l = c.createElement("a");
              l.setAttribute("href", g[0]), f.openSinglePage([l], l);
            }
          }
        },
        _createMarkup: function() {
          var b = this,
            d = "";
          "singlePage" === b.type &&
            "left" !== b.options.singlePageAnimation &&
            (d = " cbp-popup-singlePage-" + b.options.singlePageAnimation),
            (b.wrap = a("<div/>", {
              class: "cbp-popup-wrap cbp-popup-" + b.type + d,
              "data-action": "lightbox" === b.type ? "close" : ""
            }).on("click.cbp", function(c) {
              if (!b.stopEvents) {
                var d = a(c.target).attr("data-action");
                b[d] && (b[d](), c.preventDefault());
              }
            })),
            (b.content = a("<div/>", { class: "cbp-popup-content" }).appendTo(
              b.wrap
            )),
            a("<div/>", { class: "cbp-popup-loadingBox" }).appendTo(b.wrap),
            "ie8" === e.Private.browser &&
              (b.bg = a("<div/>", {
                class: "cbp-popup-ie8bg",
                "data-action": "lightbox" === b.type ? "close" : ""
              }).appendTo(b.wrap)),
            (b.navigationWrap = a("<div/>", {
              class: "cbp-popup-navigation-wrap"
            }).appendTo(b.wrap)),
            (b.navigation = a("<div/>", {
              class: "cbp-popup-navigation"
            }).appendTo(b.navigationWrap)),
            (b.closeButton = a("<div/>", {
              class: "cbp-popup-close",
              title: "Close (Esc arrow key)",
              "data-action": "close"
            }).appendTo(b.navigation)),
            (b.nextButton = a("<div/>", {
              class: "cbp-popup-next",
              title: "Next (Right arrow key)",
              "data-action": "next"
            }).appendTo(b.navigation)),
            (b.prevButton = a("<div/>", {
              class: "cbp-popup-prev",
              title: "Previous (Left arrow key)",
              "data-action": "prev"
            }).appendTo(b.navigation)),
            "singlePage" === b.type &&
              (b.options.singlePageCounter &&
                ((b.counter = a(b.options.singlePageCounter).appendTo(
                  b.navigation
                )),
                b.counter.text("")),
              b.content.on("click.cbp", b.options.singlePageDelegate, function(
                a
              ) {
                a.preventDefault();
                var c,
                  d = b.dataArray.length,
                  e = this.getAttribute("href");
                for (c = 0; d > c && b.dataArray[c].url !== e; c++);
                b.singlePageJumpTo(c - b.current);
              }),
              b.wrap.on("mousewheel.cbp DOMMouseScroll.cbp", function(a) {
                a.stopImmediatePropagation();
              })),
            a(c).on("keydown.cbp", function(a) {
              b.isOpen &&
                (b.stopEvents ||
                  (37 === a.keyCode
                    ? b.prev()
                    : 39 === a.keyCode
                    ? b.next()
                    : 27 === a.keyCode && b.close()));
            });
        },
        _createMarkupSinglePageInline: function() {
          var b = this;
          (b.wrap = a("<div/>", { class: "cbp-popup-singlePageInline" }).on(
            "click.cbp",
            function(c) {
              if (!b.stopEvents) {
                var d = a(c.target).attr("data-action");
                d && b[d] && (b[d](), c.preventDefault());
              }
            }
          )),
            (b.content = a("<div/>", { class: "cbp-popup-content" }).appendTo(
              b.wrap
            )),
            (b.navigation = a("<div/>", {
              class: "cbp-popup-navigation"
            }).appendTo(b.wrap)),
            (b.closeButton = a("<div/>", {
              class: "cbp-popup-close",
              title: "Close (Esc arrow key)",
              "data-action": "close"
            }).appendTo(b.navigation));
        },
        destroy: function() {
          var b = this,
            d = a("body");
          a(c).off("keydown.cbp"),
            d.off("click.cbp", b.options.lightboxDelegate),
            d.off("click.cbp", b.options.singlePageDelegate),
            b.content.off("click.cbp", b.options.singlePageDelegate),
            b.cubeportfolio.$obj.off(
              "click.cbp",
              b.options.singlePageInlineDelegate
            ),
            b.cubeportfolio.$obj.off("click.cbp", b.options.lightboxDelegate),
            b.cubeportfolio.$obj.off("click.cbp", b.options.singlePageDelegate),
            b.cubeportfolio.$obj.removeClass("cbp-popup-isOpening"),
            b.cubeportfolio.$obj
              .find(".cbp-item")
              .removeClass("cbp-singlePageInline-active"),
            b.wrap.remove();
        },
        openLightbox: function(d, e) {
          var f,
            g,
            h = this,
            i = 0,
            j = [];
          if (!h.isOpen) {
            if (
              ((h.isOpen = !0),
              (h.stopEvents = !1),
              (h.dataArray = []),
              (h.current = null),
              (f = e.getAttribute("href")),
              null === f)
            )
              throw new Error(
                "HEI! Your clicked element doesn't have a href attribute."
              );
            a.each(d, function(b, c) {
              var d,
                e = c.getAttribute("href"),
                g = e,
                k = "isImage";
              if (-1 === a.inArray(e, j)) {
                if (f === e) h.current = i;
                else if (!h.options.lightboxGallery) return;
                /youtube/i.test(e)
                  ? ((d = e.substring(e.lastIndexOf("v=") + 2)),
                    /autoplay=/i.test(d) || (d += "&autoplay=1"),
                    (d = d.replace(/\?|&/, "?")),
                    (g = "//www.youtube.com/embed/" + d),
                    (k = "isYoutube"))
                  : /vimeo/i.test(e)
                  ? ((d = e.substring(e.lastIndexOf("/") + 1)),
                    /autoplay=/i.test(d) || (d += "&autoplay=1"),
                    (d = d.replace(/\?|&/, "?")),
                    (g = "//player.vimeo.com/video/" + d),
                    (k = "isVimeo"))
                  : /ted\.com/i.test(e)
                  ? ((g =
                      "http://embed.ted.com/talks/" +
                      e.substring(e.lastIndexOf("/") + 1) +
                      ".html"),
                    (k = "isTed"))
                  : /soundcloud\.com/i.test(e)
                  ? ((g = e), (k = "isSoundCloud"))
                  : /(\.mp4)|(\.ogg)|(\.ogv)|(\.webm)/i.test(e)
                  ? ((g = e.split(-1 !== e.indexOf("|") ? "|" : "%7C")),
                    (k = "isSelfHostedVideo"))
                  : /\.mp3$/i.test(e) && ((g = e), (k = "isSelfHostedAudio")),
                  h.dataArray.push({
                    src: g,
                    title: c.getAttribute(h.options.lightboxTitleSrc),
                    type: k
                  }),
                  i++;
              }
              j.push(e);
            }),
              (h.counterTotal = h.dataArray.length),
              1 === h.counterTotal
                ? (h.nextButton.hide(),
                  h.prevButton.hide(),
                  (h.dataActionImg = ""))
                : (h.nextButton.show(),
                  h.prevButton.show(),
                  (h.dataActionImg = 'data-action="next"')),
              h.wrap.appendTo(c.body),
              (h.scrollTop = a(b).scrollTop()),
              (h.originalStyle = a("html").attr("style")),
              a("html").css({
                overflow: "hidden",
                paddingRight: b.innerWidth - a(c).width()
              }),
              h.wrap.show(),
              (g = h.dataArray[h.current]),
              h[g.type](g);
          }
        },
        openSinglePage: function(d, f) {
          var g,
            h = this,
            i = 0,
            j = [];
          if (!h.isOpen) {
            if (
              (h.cubeportfolio.singlePageInline &&
                h.cubeportfolio.singlePageInline.isOpen &&
                h.cubeportfolio.singlePageInline.close(),
              (h.isOpen = !0),
              (h.stopEvents = !1),
              (h.dataArray = []),
              (h.current = null),
              (g = f.getAttribute("href")),
              null === g)
            )
              throw new Error(
                "HEI! Your clicked element doesn't have a href attribute."
              );
            if (
              (a.each(d, function(b, c) {
                var d = c.getAttribute("href");
                -1 === a.inArray(d, j) &&
                  (g === d && (h.current = i),
                  h.dataArray.push({ url: d, element: c }),
                  i++),
                  j.push(d);
              }),
              (h.counterTotal = h.dataArray.length),
              1 === h.counterTotal
                ? (h.nextButton.hide(), h.prevButton.hide())
                : (h.nextButton.show(), h.prevButton.show()),
              h.wrap.appendTo(c.body),
              (h.scrollTop = a(b).scrollTop()),
              a("html").css({
                overflow: "hidden",
                paddingRight: b.innerWidth - a(c).width()
              }),
              h.wrap.scrollTop(0),
              h.wrap.show(),
              (h.finishOpen = 2),
              (h.navigationMobile = a()),
              h.wrap.one(e.Private.transitionend, function() {
                var b;
                h.options.singlePageStickyNavigation &&
                  (h.wrap.addClass("cbp-popup-singlePage-sticky"),
                  (b = h.wrap[0].clientWidth),
                  h.navigationWrap.width(b),
                  ("android" === e.Private.browser ||
                    "ios" === e.Private.browser) &&
                    ((h.navigationMobile = a("<div/>", {
                      class: "cbp-popup-singlePage cbp-popup-singlePage-sticky",
                      id: h.wrap.attr("id")
                    }).on("click.cbp", function(b) {
                      if (!h.stopEvents) {
                        var c = a(b.target).attr("data-action");
                        h[c] && (h[c](), b.preventDefault());
                      }
                    })),
                    h.navigationMobile
                      .appendTo(c.body)
                      .append(h.navigationWrap))),
                  h.finishOpen--,
                  h.finishOpen <= 0 && h.updateSinglePageIsOpen.call(h);
              }),
              "ie8" === e.Private.browser || "ie9" === e.Private.browser)
            ) {
              if (h.options.singlePageStickyNavigation) {
                var k = h.wrap[0].clientWidth;
                h.navigationWrap.width(k),
                  setTimeout(function() {
                    h.wrap.addClass("cbp-popup-singlePage-sticky");
                  }, 1e3);
              }
              h.finishOpen--;
            }
            h.wrap.addClass("cbp-popup-loading"),
              h.wrap.offset(),
              h.wrap.addClass("cbp-popup-singlePage-open"),
              h.options.singlePageDeeplinking &&
                ((h.url = h.url.split("#cbp=")[0]),
                (location.href = h.url + "#cbp=" + h.dataArray[h.current].url)),
              a.isFunction(h.options.singlePageCallback) &&
                h.options.singlePageCallback.call(
                  h,
                  h.dataArray[h.current].url,
                  h.dataArray[h.current].element
                );
          }
        },
        openSinglePageInline: function(c, d, e) {
          var f,
            g,
            h,
            i,
            j = this;
          if (
            ((e = e || !1),
            (j.fromOpen = e),
            (j.storeBlocks = c),
            (j.storeCurrentBlock = d),
            j.isOpen)
          )
            return (
              (g = a(d)
                .closest(".cbp-item")
                .index()),
              void (j.dataArray[j.current].url !== d.getAttribute("href") ||
              j.current !== g
                ? j.cubeportfolio.singlePageInline.close("open", {
                    blocks: c,
                    currentBlock: d,
                    fromOpen: !0
                  })
                : j.close())
            );
          if (
            ((j.isOpen = !0),
            (j.stopEvents = !1),
            (j.dataArray = []),
            (j.current = null),
            (f = d.getAttribute("href")),
            null === f)
          )
            throw new Error(
              "HEI! Your clicked element doesn't have a href attribute."
            );
          if (
            ((h = a(d).closest(".cbp-item")[0]),
            c.each(function(a, b) {
              h === b && (j.current = a);
            }),
            (j.dataArray[j.current] = { url: f, element: d }),
            (i = a(j.dataArray[j.current].element)
              .parents(".cbp-item")
              .addClass("cbp-singlePageInline-active")),
            (j.counterTotal = c.length),
            j.wrap.insertBefore(j.cubeportfolio.wrapper),
            "top" === j.options.singlePageInlinePosition
              ? ((j.startInline = 0),
                (j.top = 0),
                (j.firstRow = !0),
                (j.lastRow = !1))
              : "bottom" === j.options.singlePageInlinePosition
              ? ((j.startInline = j.counterTotal),
                (j.top = j.cubeportfolio.height),
                (j.firstRow = !1),
                (j.lastRow = !0))
              : "above" === j.options.singlePageInlinePosition
              ? ((j.startInline =
                  j.cubeportfolio.cols *
                  Math.floor(j.current / j.cubeportfolio.cols)),
                (j.top = a(c[j.current]).data("cbp").top),
                0 === j.startInline
                  ? (j.firstRow = !0)
                  : ((j.top -= j.options.gapHorizontal), (j.firstRow = !1)),
                (j.lastRow = !1))
              : ((j.top =
                  a(c[j.current]).data("cbp").top +
                  a(c[j.current]).data("cbp").height),
                (j.startInline = Math.min(
                  j.cubeportfolio.cols *
                    (Math.floor(j.current / j.cubeportfolio.cols) + 1),
                  j.counterTotal
                )),
                (j.firstRow = !1),
                (j.lastRow = j.startInline === j.counterTotal ? !0 : !1)),
            (j.wrap[0].style.height = j.wrap.outerHeight(!0) + "px"),
            (j.deferredInline = a.Deferred()),
            j.options.singlePageInlineInFocus)
          ) {
            j.scrollTop = a(b).scrollTop();
            var k = j.cubeportfolio.$obj.offset().top + j.top - 100;
            j.scrollTop !== k
              ? a("html,body")
                  .animate({ scrollTop: k }, 350)
                  .promise()
                  .then(function() {
                    j._resizeSinglePageInline(), j.deferredInline.resolve();
                  })
              : (j._resizeSinglePageInline(), j.deferredInline.resolve());
          } else j._resizeSinglePageInline(), j.deferredInline.resolve();
          j.cubeportfolio.$obj.addClass("cbp-popup-singlePageInline-open"),
            j.wrap.css({ top: j.top }),
            a.isFunction(j.options.singlePageInlineCallback) &&
              j.options.singlePageInlineCallback.call(
                j,
                j.dataArray[j.current].url,
                j.dataArray[j.current].element
              );
        },
        _resizeSinglePageInline: function() {
          var a = this;
          (a.height =
            a.firstRow || a.lastRow
              ? a.wrap.outerHeight(!0)
              : a.wrap.outerHeight(!0) - a.options.gapHorizontal),
            a.storeBlocks.each(function(b, c) {
              b < a.startInline
                ? e.Private.modernBrowser
                  ? (c.style[e.Private.transform] = "")
                  : (c.style.marginTop = "")
                : e.Private.modernBrowser
                ? (c.style[e.Private.transform] =
                    "translate3d(0px, " + a.height + "px, 0)")
                : (c.style.marginTop = a.height + "px");
            }),
            (a.cubeportfolio.obj.style.height =
              a.cubeportfolio.height + a.height + "px");
        },
        _revertResizeSinglePageInline: function() {
          var b = this;
          (b.deferredInline = a.Deferred()),
            b.storeBlocks.each(function(a, b) {
              e.Private.modernBrowser
                ? (b.style[e.Private.transform] = "")
                : (b.style.marginTop = "");
            }),
            (b.cubeportfolio.obj.style.height = b.cubeportfolio.height + "px");
        },
        appendScriptsToWrap: function(a) {
          var b = this,
            d = 0,
            e = function(f) {
              var g = c.createElement("script"),
                h = f.src;
              (g.type = "text/javascript"),
                g.readyState
                  ? (g.onreadystatechange = function() {
                      ("loaded" == g.readyState ||
                        "complete" == g.readyState) &&
                        ((g.onreadystatechange = null), d++, a[d] && e(a[d]));
                    })
                  : (g.onload = function() {
                      d++, a[d] && e(a[d]);
                    }),
                h ? (g.src = h) : (g.text = f.text),
                b.content[0].appendChild(g);
            };
          e(a[0]);
        },
        updateSinglePage: function(b, c, d) {
          var e,
            f = this;
          f.content
            .addClass("cbp-popup-content")
            .removeClass("cbp-popup-content-basic"),
            d === !1 &&
              f.content
                .removeClass("cbp-popup-content")
                .addClass("cbp-popup-content-basic"),
            f.counter &&
              ((e = a(
                f._getCounterMarkup(
                  f.options.singlePageCounter,
                  f.current + 1,
                  f.counterTotal
                )
              )),
              f.counter.text(e.text())),
            f.content.html(b),
            c && f.appendScriptsToWrap(c),
            f.cubeportfolio.$obj.trigger("updateSinglePageStart.cbp"),
            f.finishOpen--,
            f.finishOpen <= 0 && f.updateSinglePageIsOpen.call(f);
        },
        updateSinglePageIsOpen: function() {
          var b,
            c = this;
          c.wrap.addClass("cbp-popup-ready"),
            c.wrap.removeClass("cbp-popup-loading"),
            (b = c.content.find(".cbp-slider")),
            b
              ? (b.find(".cbp-slider-item").addClass("cbp-item"),
                (c.slider = b.cubeportfolio({
                  layoutMode: "slider",
                  mediaQueries: [{ width: 1, cols: 1 }],
                  gapHorizontal: 0,
                  gapVertical: 0,
                  caption: "",
                  coverRatio: ""
                })))
              : (c.slider = null),
            ("android" === e.Private.browser || "ios" === e.Private.browser) &&
              a("html").css({ position: "fixed" }),
            c.cubeportfolio.$obj.trigger("updateSinglePageComplete.cbp");
        },
        updateSinglePageInline: function(a, b) {
          var c = this;
          c.content.html(a),
            b && c.appendScriptsToWrap(b),
            c.cubeportfolio.$obj.trigger("updateSinglePageInlineStart.cbp"),
            c.singlePageInlineIsOpen.call(c);
        },
        singlePageInlineIsOpen: function() {
          function a() {
            b.wrap.addClass("cbp-popup-singlePageInline-ready"),
              (b.wrap[0].style.height = ""),
              b._resizeSinglePageInline(),
              b.cubeportfolio.$obj.trigger(
                "updateSinglePageInlineComplete.cbp"
              );
          }
          var b = this;
          b.cubeportfolio._load(b.wrap, function() {
            var c = b.content.find(".cbp-slider");
            c.length
              ? (c.find(".cbp-slider-item").addClass("cbp-item"),
                c.one("initComplete.cbp", function() {
                  b.deferredInline.done(a);
                }),
                c.on("pluginResize.cbp", function() {
                  b.deferredInline.done(a);
                }),
                (b.slider = c.cubeportfolio({
                  layoutMode: "slider",
                  displayType: "default",
                  mediaQueries: [{ width: 1, cols: 1 }],
                  gapHorizontal: 0,
                  gapVertical: 0,
                  caption: "",
                  coverRatio: ""
                })))
              : ((b.slider = null), b.deferredInline.done(a));
          });
        },
        isImage: function(b) {
          var c = this,
            d = new Image();
          c.tooggleLoading(!0),
            a('<img src="' + b.src + '">').is("img:uncached")
              ? (a(d).on("load.cbp error.cbp", function() {
                  c.updateImagesMarkup(
                    b.src,
                    b.title,
                    c._getCounterMarkup(
                      c.options.lightboxCounter,
                      c.current + 1,
                      c.counterTotal
                    )
                  ),
                    c.tooggleLoading(!1);
                }),
                (d.src = b.src))
              : (c.updateImagesMarkup(
                  b.src,
                  b.title,
                  c._getCounterMarkup(
                    c.options.lightboxCounter,
                    c.current + 1,
                    c.counterTotal
                  )
                ),
                c.tooggleLoading(!1));
        },
        isVimeo: function(a) {
          var b = this;
          b.updateVideoMarkup(
            a.src,
            a.title,
            b._getCounterMarkup(
              b.options.lightboxCounter,
              b.current + 1,
              b.counterTotal
            )
          );
        },
        isYoutube: function(a) {
          var b = this;
          b.updateVideoMarkup(
            a.src,
            a.title,
            b._getCounterMarkup(
              b.options.lightboxCounter,
              b.current + 1,
              b.counterTotal
            )
          );
        },
        isTed: function(a) {
          var b = this;
          b.updateVideoMarkup(
            a.src,
            a.title,
            b._getCounterMarkup(
              b.options.lightboxCounter,
              b.current + 1,
              b.counterTotal
            )
          );
        },
        isSoundCloud: function(a) {
          var b = this;
          b.updateVideoMarkup(
            a.src,
            a.title,
            b._getCounterMarkup(
              b.options.lightboxCounter,
              b.current + 1,
              b.counterTotal
            )
          );
        },
        isSelfHostedVideo: function(a) {
          var b = this;
          b.updateSelfHostedVideo(
            a.src,
            a.title,
            b._getCounterMarkup(
              b.options.lightboxCounter,
              b.current + 1,
              b.counterTotal
            )
          );
        },
        isSelfHostedAudio: function(a) {
          var b = this;
          b.updateSelfHostedAudio(
            a.src,
            a.title,
            b._getCounterMarkup(
              b.options.lightboxCounter,
              b.current + 1,
              b.counterTotal
            )
          );
        },
        _getCounterMarkup: function(a, b, c) {
          if (!a.length) return "";
          var d = { current: b, total: c };
          return a.replace(/\{\{current}}|\{\{total}}/gi, function(a) {
            return d[a.slice(2, -2)];
          });
        },
        updateSelfHostedVideo: function(a, b, c) {
          var d,
            e = this;
          e.wrap.addClass("cbp-popup-lightbox-isIframe");
          var f =
            '<div class="cbp-popup-lightbox-iframe"><video controls="controls" height="auto" style="width: 100%">';
          for (d = 0; d < a.length; d++)
            /(\.mp4)/i.test(a[d])
              ? (f += '<source src="' + a[d] + '" type="video/mp4">')
              : /(\.ogg)|(\.ogv)/i.test(a[d])
              ? (f += '<source src="' + a[d] + '" type="video/ogg">')
              : /(\.webm)/i.test(a[d]) &&
                (f += '<source src="' + a[d] + '" type="video/webm">');
          (f +=
            'Your browser does not support the video tag.</video><div class="cbp-popup-lightbox-bottom">' +
            (b ? '<div class="cbp-popup-lightbox-title">' + b + "</div>" : "") +
            c +
            "</div></div>"),
            e.content.html(f),
            e.wrap.addClass("cbp-popup-ready"),
            e.preloadNearbyImages();
        },
        updateSelfHostedAudio: function(a, b, c) {
          var d = this;
          d.wrap.addClass("cbp-popup-lightbox-isIframe");
          var e =
            '<div class="cbp-popup-lightbox-iframe"><audio controls="controls" height="auto" style="width: 100%"><source src="' +
            a +
            '" type="audio/mpeg">Your browser does not support the audio tag.</audio><div class="cbp-popup-lightbox-bottom">' +
            (b ? '<div class="cbp-popup-lightbox-title">' + b + "</div>" : "") +
            c +
            "</div></div>";
          d.content.html(e),
            d.wrap.addClass("cbp-popup-ready"),
            d.preloadNearbyImages();
        },
        updateVideoMarkup: function(a, b, c) {
          var d = this;
          d.wrap.addClass("cbp-popup-lightbox-isIframe");
          var e =
            '<div class="cbp-popup-lightbox-iframe"><iframe src="' +
            a +
            '" frameborder="0" allowfullscreen scrolling="no"></iframe><div class="cbp-popup-lightbox-bottom">' +
            (b ? '<div class="cbp-popup-lightbox-title">' + b + "</div>" : "") +
            c +
            "</div></div>";
          d.content.html(e),
            d.wrap.addClass("cbp-popup-ready"),
            d.preloadNearbyImages();
        },
        updateImagesMarkup: function(a, b, c) {
          var d = this;
          d.wrap.removeClass("cbp-popup-lightbox-isIframe");
          var e =
            '<div class="cbp-popup-lightbox-figure"><img src="' +
            a +
            '" class="cbp-popup-lightbox-img" ' +
            d.dataActionImg +
            ' /><div class="cbp-popup-lightbox-bottom">' +
            (b ? '<div class="cbp-popup-lightbox-title">' + b + "</div>" : "") +
            c +
            "</div></div>";
          d.content.html(e),
            d.wrap.addClass("cbp-popup-ready"),
            d.resizeImage(),
            d.preloadNearbyImages();
        },
        next: function() {
          var a = this;
          a[a.type + "JumpTo"](1);
        },
        prev: function() {
          var a = this;
          a[a.type + "JumpTo"](-1);
        },
        lightboxJumpTo: function(a) {
          var b,
            c = this;
          (c.current = c.getIndex(c.current + a)),
            (b = c.dataArray[c.current]),
            c[b.type](b);
        },
        singlePageJumpTo: function(b) {
          var c = this;
          (c.current = c.getIndex(c.current + b)),
            a.isFunction(c.options.singlePageCallback) &&
              (c.resetWrap(),
              c.wrap.scrollTop(0),
              c.wrap.addClass("cbp-popup-loading"),
              c.options.singlePageCallback.call(
                c,
                c.dataArray[c.current].url,
                c.dataArray[c.current].element
              ),
              c.options.singlePageDeeplinking &&
                (location.href = c.url + "#cbp=" + c.dataArray[c.current].url));
        },
        resetWrap: function() {
          var a = this;
          "singlePage" === a.type &&
            a.options.singlePageDeeplinking &&
            (location.href = a.url + "#");
        },
        getIndex: function(a) {
          var b = this;
          return (a %= b.counterTotal), 0 > a && (a = b.counterTotal + a), a;
        },
        close: function(c, d) {
          function f() {
            h.content.html(""),
              h.wrap.detach(),
              h.cubeportfolio.$obj.removeClass(
                "cbp-popup-singlePageInline-open cbp-popup-singlePageInline-close"
              ),
              "promise" === c &&
                a.isFunction(d.callback) &&
                d.callback.call(h.cubeportfolio);
          }
          function g() {
            h.options.singlePageInlineInFocus && "promise" !== c
              ? a("html,body")
                  .animate({ scrollTop: h.scrollTop }, 350)
                  .promise()
                  .then(function() {
                    f();
                  })
              : f();
          }
          var h = this;
          (h.isOpen = !1),
            "singlePageInline" === h.type
              ? "open" === c
                ? (h.wrap.removeClass("cbp-popup-singlePageInline-ready"),
                  a(h.dataArray[h.current].element)
                    .closest(".cbp-item")
                    .removeClass("cbp-singlePageInline-active"),
                  h.openSinglePageInline(d.blocks, d.currentBlock, d.fromOpen))
                : ((h.height = 0),
                  h._revertResizeSinglePageInline(),
                  h.wrap.removeClass("cbp-popup-singlePageInline-ready"),
                  h.cubeportfolio.$obj.addClass(
                    "cbp-popup-singlePageInline-close"
                  ),
                  (h.startInline = -1),
                  h.cubeportfolio.$obj
                    .find(".cbp-item")
                    .removeClass("cbp-singlePageInline-active"),
                  e.Private.modernBrowser
                    ? h.wrap.one(e.Private.transitionend, function() {
                        g();
                      })
                    : g())
              : "singlePage" === h.type
              ? (h.resetWrap(),
                h.wrap.removeClass("cbp-popup-ready"),
                ("android" === e.Private.browser ||
                  "ios" === e.Private.browser) &&
                  (a("html").css({ position: "" }),
                  h.navigationWrap.appendTo(h.wrap),
                  h.navigationMobile.remove()),
                a(b).scrollTop(h.scrollTop),
                setTimeout(function() {
                  (h.stopScroll = !0),
                    h.navigationWrap.css({ top: h.wrap.scrollTop() }),
                    h.wrap.removeClass(
                      "cbp-popup-singlePage-open cbp-popup-singlePage-sticky"
                    ),
                    ("ie8" === e.Private.browser ||
                      "ie9" === e.Private.browser) &&
                      (h.content.html(""),
                      h.wrap.detach(),
                      a("html").css({
                        overflow: "",
                        paddingRight: "",
                        position: ""
                      }),
                      h.navigationWrap.removeAttr("style"));
                }, 0),
                h.wrap.one(e.Private.transitionend, function() {
                  h.content.html(""),
                    h.wrap.detach(),
                    a("html").css({
                      overflow: "",
                      paddingRight: "",
                      position: ""
                    }),
                    h.navigationWrap.removeAttr("style");
                }))
              : (h.originalStyle
                  ? a("html").attr("style", h.originalStyle)
                  : a("html").css({ overflow: "", paddingRight: "" }),
                a(b).scrollTop(h.scrollTop),
                h.content.html(""),
                h.wrap.detach());
        },
        tooggleLoading: function(a) {
          var b = this;
          (b.stopEvents = a),
            b.wrap[a ? "addClass" : "removeClass"]("cbp-popup-loading");
        },
        resizeImage: function() {
          if (this.isOpen) {
            var c = a(b).height(),
              d = this.content.find("img"),
              e =
                parseInt(d.css("margin-top"), 10) +
                parseInt(d.css("margin-bottom"), 10);
            d.css("max-height", c - e + "px");
          }
        },
        preloadNearbyImages: function() {
          var b,
            c,
            d = [],
            e = this;
          d.push(e.getIndex(e.current + 1)),
            d.push(e.getIndex(e.current + 2)),
            d.push(e.getIndex(e.current + 3)),
            d.push(e.getIndex(e.current - 1)),
            d.push(e.getIndex(e.current - 2)),
            d.push(e.getIndex(e.current - 3));
          for (var f = d.length - 1; f >= 0; f--)
            "isImage" === e.dataArray[d[f]].type &&
              ((c = e.dataArray[d[f]].src),
              (b = new Image()),
              a('<img src="' + c + '">').is("img:uncached") && (b.src = c));
        }
      },
      g = !1,
      h = !1;
    (d.prototype.run = function() {
      var b = this,
        d = b.parent,
        e = a(c.body);
      (d.lightbox = null),
        d.options.lightboxDelegate &&
          !g &&
          ((g = !0),
          (d.lightbox = Object.create(f)),
          d.lightbox.init(d, "lightbox"),
          e.on("click.cbp", d.options.lightboxDelegate, function(c) {
            c.preventDefault();
            var e = a(this),
              f = e.attr("data-cbp-lightbox"),
              g = b.detectScope(e),
              h = g.data("cubeportfolio"),
              i = [];
            h
              ? h.blocksOn.each(function(b, c) {
                  var e = a(c);
                  e.not(".cbp-item-off") &&
                    e.find(d.options.lightboxDelegate).each(function(b, c) {
                      f
                        ? a(c).attr("data-cbp-lightbox") === f && i.push(c)
                        : i.push(c);
                    });
                })
              : (i = g.find(
                  f
                    ? d.options.lightboxDelegate +
                        "[data-cbp-lightbox=" +
                        f +
                        "]"
                    : d.options.lightboxDelegate
                )),
              d.lightbox.openLightbox(i, e[0]);
          })),
        (d.singlePage = null),
        d.options.singlePageDelegate &&
          !h &&
          ((h = !0),
          (d.singlePage = Object.create(f)),
          d.singlePage.init(d, "singlePage"),
          e.on("click.cbp", d.options.singlePageDelegate, function(c) {
            c.preventDefault();
            var e = a(this),
              f = e.attr("data-cbp-singlePage"),
              g = b.detectScope(e),
              h = g.data("cubeportfolio"),
              i = [];
            h
              ? h.blocksOn.each(function(b, c) {
                  var e = a(c);
                  e.not(".cbp-item-off") &&
                    e.find(d.options.singlePageDelegate).each(function(b, c) {
                      f
                        ? a(c).attr("data-cbp-singlePage") === f && i.push(c)
                        : i.push(c);
                    });
                })
              : (i = g.find(
                  f
                    ? d.options.singlePageDelegate +
                        "[data-cbp-singlePage=" +
                        f +
                        "]"
                    : d.options.singlePageDelegate
                )),
              d.singlePage.openSinglePage(i, e[0]);
          })),
        (d.singlePageInline = null),
        d.options.singlePageDelegate &&
          ((d.singlePageInline = Object.create(f)),
          d.singlePageInline.init(d, "singlePageInline"),
          d.$obj.on("click.cbp", d.options.singlePageInlineDelegate, function(
            a
          ) {
            a.preventDefault(),
              d.singlePageInline.openSinglePageInline(d.blocksOn, this);
          }));
    }),
      (d.prototype.detectScope = function(b) {
        var d, e, f;
        return (
          (d = b.closest(".cbp-popup-singlePageInline")),
          d.length
            ? ((f = b.closest(".cbp", d[0])), f.length ? f : d)
            : ((e = b.closest(".cbp-popup-singlePage")),
              e.length
                ? ((f = b.closest(".cbp", e[0])), f.length ? f : e)
                : ((f = b.closest(".cbp")), f.length ? f : a(c.body)))
        );
      }),
      (d.prototype.destroy = function() {
        var b = this.parent;
        a(c.body).off("click.cbp"),
          (g = !1),
          (h = !1),
          b.lightbox && b.lightbox.destroy(),
          b.singlePage && b.singlePage.destroy(),
          b.singlePageInline && b.singlePageInline.destroy();
      }),
      (e.Plugins.PopUp = function(a) {
        return new d(a);
      });
  })(jQuery, window, document),
  (function(a, b, c, d) {
    "use strict";
    var e = a.fn.cubeportfolio.Constructor;
    (e.Private = {
      checkInstance: function(b) {
        var c = a.data(this, "cubeportfolio");
        if (!c)
          throw new Error(
            "cubeportfolio is not initialized. Initialize it before calling " +
              b +
              " method!"
          );
        return c;
      },
      browserInfo: function() {
        var a,
          c,
          f,
          g = e.Private,
          h = navigator.appVersion;
        (g.browser =
          -1 !== h.indexOf("MSIE 8.")
            ? "ie8"
            : -1 !== h.indexOf("MSIE 9.")
            ? "ie9"
            : -1 !== h.indexOf("MSIE 10.")
            ? "ie10"
            : b.ActiveXObject || "ActiveXObject" in b
            ? "ie11"
            : /android/gi.test(h)
            ? "android"
            : /iphone|ipad|ipod/gi.test(h)
            ? "ios"
            : /chrome/gi.test(h)
            ? "chrome"
            : ""),
          (f = g.styleSupport("perspective")),
          typeof f !== d &&
            ((a = g.styleSupport("transition")),
            (g.transitionend = {
              WebkitTransition: "webkitTransitionEnd",
              transition: "transitionend"
            }[a]),
            (c = g.styleSupport("animation")),
            (g.animationend = {
              WebkitAnimation: "webkitAnimationEnd",
              animation: "animationend"
            }[c]),
            (g.animationDuration = {
              WebkitAnimation: "webkitAnimationDuration",
              animation: "animationDuration"
            }[c]),
            (g.animationDelay = {
              WebkitAnimation: "webkitAnimationDelay",
              animation: "animationDelay"
            }[c]),
            (g.transform = g.styleSupport("transform")),
            a && c && g.transform && (g.modernBrowser = !0));
      },
      styleSupport: function(a) {
        var b,
          d = "Webkit" + a.charAt(0).toUpperCase() + a.slice(1),
          e = c.createElement("div");
        return a in e.style ? (b = a) : d in e.style && (b = d), (e = null), b;
      }
    }),
      e.Private.browserInfo();
  })(jQuery, window, document),
  (function(a, b, c) {
    "use strict";
    var d = a.fn.cubeportfolio.Constructor;
    d.Public = {
      init: function(a, b) {
        new d(this, a, b);
      },
      destroy: function(e) {
        var f = d.Private.checkInstance.call(this, "destroy");
        f._triggerEvent("beforeDestroy"),
          a.removeData(this, "cubeportfolio"),
          f.blocks.each(function() {
            a.removeData(this, "cbp-wxh");
          }),
          f.$obj
            .removeClass("cbp-ready cbp-addItemscbp-cols-" + f.cols)
            .removeAttr("style"),
          f.$ul.removeClass("cbp-wrapper"),
          a(b).off("resize.cbp"),
          f.$obj.off(".cbp"),
          a(c).off(".cbp"),
          f.blocks.removeClass("cbp-item-off").removeAttr("style"),
          f.blocks
            .find(".cbp-item-wrapper")
            .children()
            .unwrap(),
          f.options.caption && f._captionDestroy(),
          f._destroySlider(),
          f.$ul.unwrap(),
          f.addedWrapp && f.blocks.unwrap(),
          a.each(f._plugins, function(a, b) {
            "function" == typeof b.destroy && b.destroy();
          }),
          a.isFunction(e) && e.call(f),
          f._triggerEvent("afterDestroy");
      },
      filter: function(b, c) {
        var e,
          f = d.Private.checkInstance.call(this, "filter");
        a.isFunction(c) && f._registerEvent("filterFinish", c, !0),
          f.isAnimating ||
            f.defaultFilter === b ||
            ((f.isAnimating = !0),
            (f.defaultFilter = b),
            f.singlePageInline && f.singlePageInline.isOpen
              ? f.singlePageInline.close("promise", {
                  callback: function() {
                    f._filter(b);
                  }
                })
              : f._filter(b),
            f.options.filterDeeplinking &&
              ((e = location.href.replace(/#cbpf=(.*?)([#|?&]|$)/gi, "")),
              (location.href = e + "#cbpf=" + b),
              f.singlePage &&
                f.singlePage.url &&
                (f.singlePage.url = location.href)));
      },
      showCounter: function(b, c) {
        var e = d.Private.checkInstance.call(this, "showCounter");
        (e.elems = b),
          a.each(b, function() {
            var b,
              c = a(this),
              d = c.data("filter");
            (b = e.blocks.filter(d).length),
              c.find(".cbp-filter-counter").text(b);
          }),
          a.isFunction(c) && c.call(e);
      },
      appendItems: function(a, b) {
        var c = d.Private.checkInstance.call(this, "appendItems");
        c.isAnimating ||
          ((c.isAnimating = !0),
          c.singlePageInline && c.singlePageInline.isOpen
            ? c.singlePageInline.close("promise", {
                callback: function() {
                  c._addItems(a, b);
                }
              })
            : c._addItems(a, b));
      }
    };
  })(jQuery, window, document),
  "function" != typeof Object.create &&
    (Object.create = function(a) {
      function b() {}
      return (b.prototype = a), new b();
    }),
  (jQuery.expr[":"].uncached = function(a) {
    if (!jQuery(a).is('img[src][src!=""]')) return !1;
    var b = new Image();
    return (
      (b.src = a.src),
      b.complete
        ? void 0 !== b.naturalWidth && 0 === b.naturalWidth
          ? !0
          : !1
        : !0
    );
  }),
  (function() {
    for (
      var a = 0, b = ["moz", "webkit"], c = 0;
      c < b.length && !window.requestAnimationFrame;
      ++c
    )
      (window.requestAnimationFrame = window[b[c] + "RequestAnimationFrame"]),
        (window.cancelAnimationFrame =
          window[b[c] + "CancelAnimationFrame"] ||
          window[b[c] + "CancelRequestAnimationFrame"]);
    window.requestAnimationFrame ||
      (window.requestAnimationFrame = function(b) {
        var c = new Date().getTime(),
          d = Math.max(0, 16 - (c - a)),
          e = window.setTimeout(function() {
            b(c + d);
          }, d);
        return (a = c + d), e;
      }),
      window.cancelAnimationFrame ||
        (window.cancelAnimationFrame = function(a) {
          clearTimeout(a);
        });
  })(),
  (function(a) {
    "use strict";
    function b(a) {
      var b = this;
      (b.parent = a), (a.filterLayout = b.filterLayout);
    }
    var c = a.fn.cubeportfolio.Constructor;
    (b.prototype.filterLayout = function(b) {
      function d() {
        e.blocks
          .removeClass("cbp-item-on2off cbp-item-off2on cbp-item-on2on")
          .each(function(b, d) {
            var e = a(d).data("cbp");
            (e.left = e.leftNew),
              (e.top = e.topNew),
              (d.style.left = e.left + "px"),
              (d.style.top = e.top + "px"),
              (d.style[c.Private.transform] = "");
          }),
          e.blocksOff.addClass("cbp-item-off"),
          e.$obj.removeClass("cbp-animation-" + e.options.animationType),
          e.filterFinish();
      }
      var e = this;
      e.$obj.addClass("cbp-animation-" + e.options.animationType),
        e.blocksOnInitial
          .filter(b)
          .addClass("cbp-item-on2on")
          .each(function(b, d) {
            var e = a(d).data("cbp");
            d.style[c.Private.transform] =
              "translate3d(" +
              (e.leftNew - e.left) +
              "px, " +
              (e.topNew - e.top) +
              "px, 0)";
          }),
        (e.blocksOn2Off = e.blocksOnInitial.not(b).addClass("cbp-item-on2off")),
        (e.blocksOff2On = e.blocksOn
          .filter(".cbp-item-off")
          .removeClass("cbp-item-off")
          .addClass("cbp-item-off2on")
          .each(function(b, c) {
            var d = a(c).data("cbp");
            (d.left = d.leftNew),
              (d.top = d.topNew),
              (c.style.left = d.left + "px"),
              (c.style.top = d.top + "px");
          })),
        e.blocksOn2Off.length
          ? e.blocksOn2Off
              .last()
              .data("cbp")
              .wrapper.one(c.Private.animationend, d)
          : e.blocksOff2On.length
          ? e.blocksOff2On
              .last()
              .data("cbp")
              .wrapper.one(c.Private.animationend, d)
          : d(),
        e._resizeMainContainer();
    }),
      (b.prototype.destroy = function() {
        var a = this.parent;
        a.$obj.removeClass("cbp-animation-" + a.options.animationType);
      }),
      (c.Plugins.AnimationClassic = function(d) {
        return !c.Private.modernBrowser ||
          a.inArray(d.options.animationType, [
            "boxShadow",
            "fadeOut",
            "flipBottom",
            "flipOut",
            "quicksand",
            "scaleSides",
            "skew"
          ]) < 0
          ? null
          : new b(d);
      });
  })(jQuery, window, document),
  (function(a) {
    "use strict";
    function b(a) {
      var b = this;
      (b.parent = a), (a.filterLayout = b.filterLayout);
    }
    var c = a.fn.cubeportfolio.Constructor;
    (b.prototype.filterLayout = function() {
      function b() {
        d.wrapper[0].removeChild(e),
          "sequentially" === d.options.animationType &&
            d.blocksOn.each(function(b, d) {
              a(d).data("cbp").wrapper[0].style[c.Private.animationDelay] = "";
            }),
          d.$obj.removeClass("cbp-animation-" + d.options.animationType),
          d.filterFinish();
      }
      var d = this,
        e = d.$ul[0].cloneNode(!0);
      e.setAttribute("class", "cbp-wrapper-helper"),
        d.wrapper[0].insertBefore(e, d.$ul[0]),
        requestAnimationFrame(function() {
          d.$obj.addClass("cbp-animation-" + d.options.animationType),
            d.blocksOff.addClass("cbp-item-off"),
            d.blocksOn.removeClass("cbp-item-off").each(function(b, e) {
              var f = a(e).data("cbp");
              (f.left = f.leftNew),
                (f.top = f.topNew),
                (e.style.left = f.left + "px"),
                (e.style.top = f.top + "px"),
                "sequentially" === d.options.animationType &&
                  (f.wrapper[0].style[c.Private.animationDelay] =
                    60 * b + "ms");
            }),
            d.blocksOn.length
              ? d.blocksOn
                  .last()
                  .data("cbp")
                  .wrapper.one(c.Private.animationend, b)
              : d.blocksOnInitial.length
              ? d.blocksOnInitial
                  .last()
                  .data("cbp")
                  .wrapper.one(c.Private.animationend, b)
              : b(),
            d._resizeMainContainer();
        });
    }),
      (b.prototype.destroy = function() {
        var a = this.parent;
        a.$obj.removeClass("cbp-animation-" + a.options.animationType);
      }),
      (c.Plugins.AnimationClone = function(d) {
        return !c.Private.modernBrowser ||
          a.inArray(d.options.animationType, [
            "fadeOutTop",
            "slideLeft",
            "sequentially"
          ]) < 0
          ? null
          : new b(d);
      });
  })(jQuery, window, document),
  (function(a) {
    "use strict";
    function b(a) {
      var b = this;
      (b.parent = a), (a.filterLayout = b.filterLayout);
    }
    var c = a.fn.cubeportfolio.Constructor;
    (b.prototype.filterLayout = function() {
      function b() {
        e.wrapper[0].removeChild(d),
          e.$obj.removeClass("cbp-animation-" + e.options.animationType),
          e.blocks.each(function(b, d) {
            a(d).data("cbp").wrapper[0].style[c.Private.animationDelay] = "";
          }),
          e.filterFinish();
      }
      var d,
        e = this;
      (d = e.$ul[0].cloneNode(!0)),
        d.setAttribute("class", "cbp-wrapper-helper"),
        e.wrapper[0].insertBefore(d, e.$ul[0]),
        a(d)
          .find(".cbp-item")
          .not(".cbp-item-off")
          .children(".cbp-item-wrapper")
          .each(function(a, b) {
            b.style[c.Private.animationDelay] = 50 * a + "ms";
          }),
        requestAnimationFrame(function() {
          e.$obj.addClass("cbp-animation-" + e.options.animationType),
            e.blocksOff.addClass("cbp-item-off"),
            e.blocksOn.removeClass("cbp-item-off").each(function(b, d) {
              var e = a(d).data("cbp");
              (e.left = e.leftNew),
                (e.top = e.topNew),
                (d.style.left = e.left + "px"),
                (d.style.top = e.top + "px"),
                (e.wrapper[0].style[c.Private.animationDelay] = 50 * b + "ms");
            }),
            e.blocksOn.length
              ? e.blocksOn
                  .last()
                  .data("cbp")
                  .wrapper.one(c.Private.animationend, b)
              : e.blocksOnInitial.length
              ? e.blocksOnInitial
                  .last()
                  .data("cbp")
                  .wrapper.one(c.Private.animationend, b)
              : b(),
            e._resizeMainContainer();
        });
    }),
      (b.prototype.destroy = function() {
        var a = this.parent;
        a.$obj.removeClass("cbp-animation-" + a.options.animationType);
      }),
      (c.Plugins.AnimationCloneDelay = function(d) {
        return !c.Private.modernBrowser ||
          a.inArray(d.options.animationType, [
            "3dflip",
            "flipOutDelay",
            "foldLeft",
            "frontRow",
            "rotateRoom",
            "rotateSides",
            "scaleDown",
            "slideDelay",
            "unfold"
          ]) < 0
          ? null
          : new b(d);
      });
  })(jQuery, window, document),
  (function(a) {
    "use strict";
    function b(a) {
      var b = this;
      (b.parent = a), (a.filterLayout = b.filterLayout);
    }
    var c = a.fn.cubeportfolio.Constructor;
    (b.prototype.filterLayout = function() {
      function b() {
        d.wrapper[0].removeChild(e),
          d.$obj.removeClass("cbp-animation-" + d.options.animationType),
          d.filterFinish();
      }
      var d = this,
        e = d.$ul[0].cloneNode(!0);
      e.setAttribute("class", "cbp-wrapper-helper"),
        d.wrapper[0].insertBefore(e, d.$ul[0]),
        requestAnimationFrame(function() {
          d.$obj.addClass("cbp-animation-" + d.options.animationType),
            d.blocksOff.addClass("cbp-item-off"),
            d.blocksOn.removeClass("cbp-item-off").each(function(b, c) {
              var d = a(c).data("cbp");
              (d.left = d.leftNew),
                (d.top = d.topNew),
                (c.style.left = d.left + "px"),
                (c.style.top = d.top + "px");
            }),
            d.blocksOn.length
              ? d.$ul.one(c.Private.animationend, b)
              : d.blocksOnInitial.length
              ? a(e).one(c.Private.animationend, b)
              : b(),
            d._resizeMainContainer();
        });
    }),
      (b.prototype.destroy = function() {
        var a = this.parent;
        a.$obj.removeClass("cbp-animation-" + a.options.animationType);
      }),
      (c.Plugins.AnimationWrapper = function(d) {
        return !c.Private.modernBrowser ||
          a.inArray(d.options.animationType, [
            "bounceBottom",
            "bounceLeft",
            "bounceTop",
            "moveLeft"
          ]) < 0
          ? null
          : new b(d);
      });
  })(jQuery, window, document),
  (function(a) {
    "use strict";
    function b(b) {
      var d = this;
      (d.parent = b),
        b._registerEvent(
          "initFinish",
          function() {
            b.$obj.on("click.cbp", ".cbp-caption-defaultWrap", function(d) {
              if ((d.preventDefault(), !b.isAnimating)) {
                b.isAnimating = !0;
                var e = a(this),
                  f = e.next(),
                  g = e.parent(),
                  h = { position: "relative", height: f.outerHeight(!0) },
                  i = { position: "relative", height: 0 };
                if (
                  (b.$obj.addClass("cbp-caption-expand-active"),
                  g.hasClass("cbp-caption-expand-open"))
                ) {
                  var j = i;
                  (i = h), (h = j), g.removeClass("cbp-caption-expand-open");
                }
                f.css(h),
                  b._gridAdjust(),
                  b._layout(),
                  b.positionateItems(),
                  b._resizeMainContainer(),
                  f.css(i),
                  requestAnimationFrame(function() {
                    g.addClass("cbp-caption-expand-open"),
                      f.one(c.Private.transitionend, function() {
                        (b.isAnimating = !1),
                          b.$obj.removeClass("cbp-caption-expand-active"),
                          0 === h.height &&
                            (g.removeClass("cbp-caption-expand-open"),
                            f.attr("style", ""));
                      }),
                      f.css(h),
                      "slider" === b.options.layoutMode && b._updateSlider(),
                      b._triggerEvent("resizeGrid");
                  });
              }
            });
          },
          !0
        );
    }
    var c = a.fn.cubeportfolio.Constructor;
    (b.prototype.destroy = function() {
      this.parent.$obj
        .find(".cbp-caption-defaultWrap")
        .off("click.cbp")
        .parent()
        .removeClass("cbp-caption-expand-active");
    }),
      (c.Plugins.CaptionExpand = function(a) {
        return "expand" !== a.options.caption ? null : new b(a);
      });
  })(jQuery, window, document),
  (function(a) {
    "use strict";
    function b(a) {
      a._skipNextEvent("delayFrame"),
        a._registerEvent(
          "initEndWrite",
          function() {
            a.blocksOn.each(function(b, d) {
              d.style[c.Private.animationDelay] =
                b * a.options.displayTypeSpeed + "ms";
            }),
              a.$obj.addClass("cbp-displayType-bottomToTop"),
              a.blocksOn.last().one(c.Private.animationend, function() {
                a.$obj.removeClass("cbp-displayType-bottomToTop"),
                  a.blocksOn.each(function(a, b) {
                    b.style[c.Private.animationDelay] = "";
                  }),
                  a._triggerEvent("delayFrame");
              });
          },
          !0
        );
    }
    var c = a.fn.cubeportfolio.Constructor;
    c.Plugins.BottomToTop = function(a) {
      return c.Private.modernBrowser &&
        "bottomToTop" === a.options.displayType &&
        0 !== a.blocks.length
        ? new b(a)
        : null;
    };
  })(jQuery, window, document),
  (function(a) {
    "use strict";
    function b(a) {
      a._skipNextEvent("delayFrame"),
        a._registerEvent(
          "initEndWrite",
          function() {
            (a.obj.style[c.Private.animationDuration] =
              a.options.displayTypeSpeed + "ms"),
              a.$obj.addClass("cbp-displayType-fadeInToTop"),
              a.$obj.one(c.Private.animationend, function() {
                a.$obj.removeClass("cbp-displayType-fadeInToTop"),
                  (a.obj.style[c.Private.animationDuration] = ""),
                  a._triggerEvent("delayFrame");
              });
          },
          !0
        );
    }
    var c = a.fn.cubeportfolio.Constructor;
    c.Plugins.FadeInToTop = function(a) {
      return c.Private.modernBrowser &&
        "fadeInToTop" === a.options.displayType &&
        0 !== a.blocks.length
        ? new b(a)
        : null;
    };
  })(jQuery, window, document),
  (function(a) {
    "use strict";
    function b(a) {
      a._skipNextEvent("delayFrame"),
        a._registerEvent(
          "initEndWrite",
          function() {
            (a.obj.style[c.Private.animationDuration] =
              a.options.displayTypeSpeed + "ms"),
              a.$obj.addClass("cbp-displayType-lazyLoading"),
              a.$obj.one(c.Private.animationend, function() {
                a.$obj.removeClass("cbp-displayType-lazyLoading"),
                  (a.obj.style[c.Private.animationDuration] = ""),
                  a._triggerEvent("delayFrame");
              });
          },
          !0
        );
    }
    var c = a.fn.cubeportfolio.Constructor;
    c.Plugins.LazyLoading = function(a) {
      return !c.Private.modernBrowser ||
        ("lazyLoading" !== a.options.displayType &&
          "fadeIn" !== a.options.displayType) ||
        0 === a.blocks.length
        ? null
        : new b(a);
    };
  })(jQuery, window, document),
  (function(a) {
    "use strict";
    function b(a) {
      a._skipNextEvent("delayFrame"),
        a._registerEvent(
          "initEndWrite",
          function() {
            a.blocksOn.each(function(b, d) {
              d.style[c.Private.animationDelay] =
                b * a.options.displayTypeSpeed + "ms";
            }),
              a.$obj.addClass("cbp-displayType-sequentially"),
              a.blocksOn.last().one(c.Private.animationend, function() {
                a.$obj.removeClass("cbp-displayType-sequentially"),
                  a.blocksOn.each(function(a, b) {
                    b.style[c.Private.animationDelay] = "";
                  }),
                  a._triggerEvent("delayFrame");
              });
          },
          !0
        );
    }
    var c = a.fn.cubeportfolio.Constructor;
    c.Plugins.DisplaySequentially = function(a) {
      return c.Private.modernBrowser &&
        "sequentially" === a.options.displayType &&
        0 !== a.blocks.length
        ? new b(a)
        : null;
    };
  })(jQuery, window, document);
